import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=0052a386&"
import script from "./HeaderInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports